import React, { useState } from "react";
import "./AdminPanel.css";
import { FaChalkboardTeacher, FaUserGraduate, FaLayerGroup, FaCalendarCheck, FaBars, FaTimes, FaCreditCard, FaEnvelope } from "react-icons/fa";

import StudentManagement from "./admin/StudentManagement";
import TeacherManagement from "./admin/TeacherManagement";
import BatchManagement from "./admin/BatchManagement";
import AttendanceManagement from "./admin/AttendanceManagement";
import StudentSubscriptionDetail from "./admin/StudentSubscriptionDetail";
import SubscriptionManagement from "./admin/SubscriptionManagmanet";
import AddSubscription from "./admin/AddSubscription";
import PlanManagement from "./admin/PlanManagement";
import PromptManagement from "./admin/PromptMng";
import ContactMng from "./admin/ContactMng";

function AdminPanel() {
  const [activeTab, setActiveTab] = useState("teachers");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Close sidebar automatically on mobile when a menu item is clicked
  const handleMenuClick = (tab) => {
    setActiveTab(tab);
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className="admin-panel">
      <div className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="sidebar-header">
          <h2>Admin Panel</h2>
          <button className="close-sidebar" onClick={toggleSidebar}>
            <FaTimes />
          </button>
        </div>

        <div className="sidebar-menu">
          <button className={activeTab === "teachers" ? "active" : ""} onClick={() => handleMenuClick("teachers")}>
            <FaChalkboardTeacher className="menu-icon" />
            <span className="menu-text">Teachers</span>
          </button>

          <button className={activeTab === "batches" ? "active" : ""} onClick={() => handleMenuClick("batches")}>
            <FaLayerGroup className="menu-icon" />
            <span className="menu-text">Batches</span>
          </button>

          <button className={activeTab === "students" ? "active" : ""} onClick={() => handleMenuClick("students")}>
            <FaUserGraduate className="menu-icon" />
            <span className="menu-text">Students</span>
          </button>

          <button className={activeTab === "attendance" ? "active" : ""} onClick={() => handleMenuClick("attendance")}>
            <FaCalendarCheck className="menu-icon" />
            <span className="menu-text">Attendance</span>
          </button>

          <button className={activeTab === "subscriptions" ? "active" : ""} onClick={() => handleMenuClick("subscriptions")}>
            <FaCreditCard className="menu-icon" />
            <span className="menu-text">Active Subscribe Student</span>
          </button>

          <button className={activeTab === "subscriptions-ana" ? "active" : ""} onClick={() => handleMenuClick("subscriptions-ana")}>
            <FaCreditCard className="menu-icon" />
            <span className="menu-text">Subscriptions</span>
          </button>

          <button className={activeTab === "add-subscriptions" ? "active" : ""} onClick={() => handleMenuClick("add-subscriptions")}>
            <FaCreditCard className="menu-icon" />
            <span className="menu-text">Manual Subscriptions</span>
          </button>

          <button className={activeTab === "plan-mng" ? "active" : ""} onClick={() => handleMenuClick("plan-mng")}>
            <FaCreditCard className="menu-icon" />
            <span className="menu-text">Course MNG</span>
          </button>

          <button className={activeTab === "prompt-mng" ? "active" : ""} onClick={() => handleMenuClick("prompt-mng")}>
            <FaCreditCard className="menu-icon" />
            <span className="menu-text">Prompt MNG</span>
          </button>

          <button className={activeTab === "contact-mng" ? "active" : ""} onClick={() => handleMenuClick("contact-mng")}>
            <FaEnvelope className="menu-icon" />
            <span className="menu-text">Contact MNG</span>
          </button>

        </div>
      </div>

      <div className="admin-content-wrapper">
        <div className="content-header">
          <button className="toggle-sidebar" onClick={toggleSidebar}>
            <FaBars />
          </button>
          <h1 className="page-title">
            {activeTab === "teachers" && "Teacher Management"}
            {activeTab === "batches" && "Batch Management"}
            {activeTab === "students" && "Student Management"}
            {activeTab === "attendance" && "Attendance Management"}
          </h1>
        </div>

        <div className="admin-content">
          {activeTab === "teachers" && <TeacherManagement />}
          {activeTab === "batches" && <BatchManagement />}
          {activeTab === "students" && <StudentManagement />}
          {activeTab === "attendance" && <AttendanceManagement />}
          {activeTab === "subscriptions" && <StudentSubscriptionDetail />}
          {activeTab === "subscriptions-ana" && <SubscriptionManagement />}
          {activeTab === "add-subscriptions" && <AddSubscription />}
          {activeTab === "plan-mng" && <PlanManagement />}
          {activeTab === "prompt-mng" && <PromptManagement />}
          {activeTab === "contact-mng" && <ContactMng />}
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;
